// Phase T3.3 — public extraction-stats hook. Soft-fail to the
// honest "accumulating" view (N01/N08 spirit) — never an error.

import { useEffect, useMemo, useState } from "react";

import { getBrowserClient } from "../supabase/browser.ts";
import {
  type ExtractionStatsView,
  shapeExtractionStats,
} from "./extractionStats.ts";

export function useExtractionStats(): {
  view: ExtractionStatsView;
  loading: boolean;
} {
  const supabase = useMemo(() => getBrowserClient(), []);
  const [view, setView] = useState<ExtractionStatsView>(
    shapeExtractionStats(null),
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data, error } = await supabase.functions.invoke(
          "extraction-stats",
          { method: "GET" },
        );
        if (!alive) return;
        if (error) {
          setView(shapeExtractionStats(null));
        } else {
          setView(shapeExtractionStats(data as never));
        }
      } catch {
        if (alive) setView(shapeExtractionStats(null));
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [supabase]);

  return { view, loading };
}
